'use client';

import { usePathname } from 'next/navigation';

import { PATH } from '@/shared/constants';
import { useProfile, useUIOverlay } from '@/shared/hooks';
import { UserMenuBox, UserMenuPopover } from '@/features/AppBar';

interface UserMenuProps {
  isAuth: boolean;
}

const UserMenu = ({ isAuth }: UserMenuProps) => {
  const pathname = usePathname();
  const { profile } = useProfile();
  const { isAuthorizedPage, isOpen, handleOpen, handleClose } = useUIOverlay();

  const isRootPath = pathname === PATH.ROOT;
  const isNeedRedirectHome = isRootPath || isAuthorizedPage;

  const nextPath = isNeedRedirectHome ? PATH.HOME : pathname;

  const openSearch = () => handleOpen('search');
  const openProfileModal = () => handleOpen('profile');
  const openProfileImageChangeModal = () => handleOpen('profileImageChange');

  const openUserMenu = () => {
    handleOpen('userMenu');
  };

  const closeUserMenu = () => {
    handleClose('userMenu');
  };

  return (
    <nav className="relative">
      <UserMenuBox
        nextPath={nextPath}
        isAuth={isAuth}
        profile={profile || undefined}
        openSearch={openSearch}
        openUserMenu={openUserMenu}
      />
      <UserMenuPopover
        isOpen={isOpen.userMenu}
        onClose={closeUserMenu}
        profile={profile}
        nextPath={nextPath}
        openProfileModal={openProfileModal}
        openProfileImageChangeModal={openProfileImageChangeModal}
      />
    </nav>
  );
};

export default UserMenu;
